import { DefaultCompanyBranchDivisionService } from "@/_services/api/sales/default-company-branch-dicision.service";
import { StockTransferService } from "@/_services/api/inventory/stock-transfer-service";
import { getFactorByCode } from "@/_store/helpers";

export async function getBranchFieldDefault($store) {
    const userDefault =
        await DefaultCompanyBranchDivisionService.getDefault();
    let defaultBranchCode = null;
    let isBranchActive = false;

    if (
        userDefault.data.value.length > 0 &&
        userDefault.data.value[0].BranchCode
    ) {
        defaultBranchCode = userDefault.data.value[0].BranchCode;
        const isActive =
            await DefaultCompanyBranchDivisionService.IsBranchActive(
                defaultBranchCode
            );

        isBranchActive = isActive.data.value.length > 0;
    }

    if (!defaultBranchCode || !isBranchActive) {
        await $store.dispatch("screenFactors/getFactors", [65]);
        const factor = getFactorByCode(65);
        if (factor) {
            defaultBranchCode = factor.Factorc;
            const isActive =
                await DefaultCompanyBranchDivisionService.IsBranchActive(
                    defaultBranchCode
                );
            isBranchActive = isActive.data.value.length > 0;
        }
    }

    if (defaultBranchCode && isBranchActive) {
        return defaultBranchCode;
    } else return null;
}


export async function getActiveAccountPeriod() {

    let DateMin = undefined;
    let DateMax = undefined;

    let startDateResult = await StockTransferService.getActiveAccountingPeriodStartDate();
    if (startDateResult) {
        let accountingPeriod = startDateResult.data.value[0];
        DateMin = new Date(accountingPeriod.StartDate);
    }

    let endDateResult = await StockTransferService.getActiveAccountingPeriodEndDate();
    if (endDateResult) {
        let accountingPeriod = endDateResult.data.value[0];
        DateMax = new Date(accountingPeriod.EndDate);
    }

    return {
        DateMin, DateMax
    }

}